import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/experience/events`;
      const body = JSON.stringify({
        user_id: "system", event: "ui_crash",
        props: { message: String(error?.message || error).slice(0, 300), path: window.location.pathname },
      });
      fetch(url, {
        method: "POST", keepalive: true,
        headers: { "Content-Type": "application/json", "X-API-Key": process.env.REACT_APP_API_KEY || "", "X-Beta-Token": localStorage.getItem("xp_beta_token") || "" },
        body,
      }).catch(() => {});
    } catch {}
  }
  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.silent) return null;
    return (
      <div
        data-testid="error-boundary"
        role="button"
        onClick={() => { window.location.href = "/experience"; }}
        className="min-h-[70vh] flex items-center justify-center px-6 cursor-pointer"
        style={{ background: "#0A0A0A", color: "#F9FAFB" }}
      >
        <div className="w-full max-w-sm rounded-3xl border p-8 text-center" style={{ borderColor: "rgba(212,175,55,0.4)", background: "#141414" }}>
          <img src="/urban-emblem.png" alt="Urban by VeerGi" className="h-14 mx-auto" />
          <p className="font-display text-2xl font-bold mt-4">Something went wrong</p>
          <p className="text-sm mt-2" style={{ color: "rgba(255,255,255,0.6)" }}>A small hiccup on this screen — nothing lost.</p>
          <span
            data-testid="error-boundary-reload"
            className="inline-flex items-center justify-center mt-6 rounded-full px-8 py-3 text-xs font-bold tracking-widest"
            style={{ background: "#D4AF37", color: "#000" }}
          >
            TAP TO RELOAD
          </span>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
